export default __webpack_public_path__ + "static/media/pulseCircle.a99c3f39.png";